import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import store from 'stores/RootStore';

import CopyLinksButton from './CopyLinksButton';
import GoBackButton from './GoBackButton';
import NavigationMenu from './NavigationMenu';
import ReloadButton from './ReloadButton';
import ScaleInput from './ScaleInput';

const Container = styled.div`
  align-items: center;
  background-color: white;
  border-bottom: 1px solid #f2ebeb;
  border-top: 1px solid #f2ebeb;
  display: flex;
  gap: 7px;
  padding: 0 7px;
  width: 100%;
`;

function AdViewToolbar() {
  const isMobile = store.ui.isMobile;

  return (
    <Container>
      {isMobile && <GoBackButton />}
      <NavigationMenu />
      <ReloadButton />
      <ScaleInput />
      {!isMobile && <CopyLinksButton />}
    </Container>
  );
}

export default observer(AdViewToolbar);
